export const enum LogoutReason {
  KEY_REASON = 'defender:logout:reason',
  FORBIDDEN = 'revoked-access',
  UNAUTHORIZED = 'unauthorized-action',
  BAD_REQUEST = 'consecutives-bad-requests',
}
export const enum EventData {
  FORCE_SIGNOUT = 'FORCE_SIGNOUT',
}
export const enum MessageCode {
  UNAUTHORIZED = '0015',
}
export const enum Messages {
  PLEASE_AUTHENTICATE = 'Please authenticate',
}
